import { type ReactNode } from 'react';
import { buttonVariants, P } from '@paypoteam/ui-components';
import type { HTMLReactParserOptions } from 'html-react-parser';
import parse, { Element } from 'html-react-parser';

import { cn } from '@/lib/utils';

// use client side only
export const parseHtmlWithStyledLinks = (html: string): ReactNode => {
    const options: HTMLReactParserOptions = {
        replace: domNode => {
            if (domNode instanceof Element && domNode.name === 'a') {
                const text = domNode.children
                    .map(child => {
                        if ('data' in child) {
                            return child.data;
                        }
                        return '';
                    })
                    .join('');

                return (
                    <a
                        href={domNode.attribs.href}
                        className={cn(
                            buttonVariants({
                                variant: 'ghost',
                            }),
                            'inline justify-start font-primary font-medium',
                            domNode.attribs.class && domNode.attribs.class
                        )}
                    >
                        {text}
                    </a>
                );
            }
            if (domNode instanceof Element && domNode.name === 'p') {
                return (
                    <P className="inline">
                        {domNode.children.map((child, index) => {
                            if ('data' in child) {
                                return <span key={index}>{child.data}</span>;
                            }
                            return null;
                        })}
                    </P>
                );
            }
        },
    };

    return parse(html || '', options);
};
